import React, { Component } from "react";
import { Row, Card, CardTitle } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import { dAPI_Unsubscribe } from '../../constants/APIs';
import { Colxx } from "../../components/common/CustomBootstrap";
import queryString from 'query-string'
import myma_logo from './../../assets/myma_logo.png';
class Unsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search)
    console.log(values);
    let data = { data: values.data };
    AxiosPublicAPI({
      method: 'delete',
      url: `${dAPI_Unsubscribe}`,
      data: data
    }).then(
      res => {
        this.setState({ success: true });
      },
      error => {
        console.log('eee.data', error.data);
      }
    );
  }

  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">AI-POWERED DIGITAL ASSISTANT FOR HOSPITALITY</p>
            </div>
            {this.state.success && (<div className="form-side">
              <NavLink to={`/`} className="white">
                <span class="logo-single"> <img src={myma_logo} width="150" height="100" /> </span>
              </NavLink>
              <CardTitle className="mb-4">
                You have been unsubscribed successfully.
              </CardTitle>
            </div>)}
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    registerUser
  }
)(Unsubscribe);
